import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';

import { queryKeys } from '~/utils/queryKeys';

// lead views and notifications that show who is assigned or active
// duplicate lists are matched by prefix: the IK row doesn't know the original lead id its list is keyed by
export const assignedUsersQueryKeys = (loanRequestId: string) => [
    queryKeys.get(loanRequestId),
    queryKeys.getSummary(),
    queryKeys.getAclPermissions({ loanRequestId }),
    [AGGREGATE_NAMES.LOAN_REQUEST, LOAN_REQUEST_RESOLVERS.getActiveUserSetLeads],
    [AGGREGATE_NAMES.LOAN_REQUEST, LOAN_REQUEST_RESOLVERS.getDuplicateInfoByLead],
];
